import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setShowFiltersModal, setOrderField } from '../../actions/filters';
import { openMap } from '../../actions/map';
import { FixedPanel } from '../../components/FixedPanel';
import { TopBar } from '../../components/TopBar';
import { useTopBarCount } from '../../hooks/topBar';
import { EOrderField } from '../../repositories/favorites/entities/get_favorites_for_desktop/GetFavoritesForDesktopRequestSchema';
import { selectMapData, selectFilters, selectResults } from '../../selectors';
import { selectSelectedFolder } from '../../selectors/folders';
import { getMapData } from '../../thunk/favorites';
import { EEntityType, ETabType } from '../../types/filters';
import { CheckboxAllContainer } from '../CheckboxAllContainer/CheckboxAllContainer';
import { MassActionsContainer } from '../MassActions';
import { TotalCountContainer } from '../TotalCountContainer';
import { selectActiveTab } from '../../selectors/activeTab';

export function TopBarContainer() {
  const dispatch = useDispatch();

  const { favoriteEntityType, orderField } = useSelector(selectFilters);
  const selectedFolder = useSelector(selectSelectedFolder);
  const { status: mapStatus } = useSelector(selectMapData);
  const { favoriteEntities } = useSelector(selectResults);
  const { activeTab } = useSelector(selectActiveTab);

  const filtersVisible = !selectedFolder && favoriteEntityType !== EEntityType.Newbuilding && activeTab !== ETabType.JK;
  const isMapVisible = Boolean(selectedFolder) && favoriteEntityType !== EEntityType.Newbuilding;
  const topBarCount = useTopBarCount();
  const isFavoriteEntitiesLength = Boolean(favoriteEntities.length);

  const handleOpenMap = () => {
    if (selectedFolder) {
      dispatch(getMapData({ folderId: selectedFolder.id }));
      dispatch(openMap());
    }
  };

  return (
    <FixedPanel>
      <TopBar
        orderField={orderField}
        checkbox={Boolean(topBarCount.count) && <CheckboxAllContainer />}
        total={<TotalCountContainer />}
        massActions={Boolean(topBarCount.count) && <MassActionsContainer />}
        filtersVisible={filtersVisible}
        isMapVisible={isMapVisible}
        isFavoriteEntitiesLength={isFavoriteEntitiesLength}
        getFavoriteEntities={(orderField?: EOrderField | null) =>
          dispatch(fetchFavoriteEntities({ offset: 0, orderField }))
        }
        setShowFiltersModal={(showFiltersModel: boolean) => dispatch(setShowFiltersModal(showFiltersModel))}
        setOrderField={(type: EOrderField) => dispatch(setOrderField(type))}
        openMap={handleOpenMap}
        mapStatus={mapStatus}
      />
    </FixedPanel>
  );
}
